export const getUserInfo = (state: any) => state?.my_account?.user_info;
export const getUserRole = (state: any) => state?.my_account?.user_info?.role;
export const getTerminology = (state: any) => state?.my_account?.user_info?.terminology ?? "Patient";
